import api from './api';
import type { CreateProfessorData, UpdateExternalProfessorData } from './professorService';

type CreateExternalProfessorForCourseData = CreateProfessorData & {
    curso_codigos: [string];
};

export default {
    async getMeuCurso() {
        return api.get('/coordenador/cursos');
    },

    async getCurso(cursoId: number) {
        return api.get(`/coordenador/cursos/${cursoId}`);
    },

    async getProfessoresCurso(cursoId: number, params?: any) {
        return api.get(`/coordenador/cursos/${cursoId}/professores`, { params });
    },

    async vincularProfessor(cursoId: number, userId: number) {
        return api.post(`/coordenador/cursos/${cursoId}/professores`, { user_id: userId });
    },

    async desvincularProfessor(cursoId: number, userId: number) {
        return api.delete(`/coordenador/cursos/${cursoId}/professores/${userId}`);
    },

    async getAlunosCurso(cursoId: number) {
        return api.get(`/coordenador/cursos/${cursoId}/alunos`);
    },

    async vincularAluno(cursoId: number, alunoId: number) {
        return api.post(`/coordenador/cursos/${cursoId}/alunos`, { aluno_id: alunoId });
    },

    async desvincularAluno(cursoId: number, alunoId: number) {
        return api.delete(`/coordenador/cursos/${cursoId}/alunos/${alunoId}`);
    },

    async atualizarStatusAluno(cursoId: number, alunoId: number, status: string) {
        return api.put(`/coordenador/cursos/${cursoId}/alunos/${alunoId}`, { status });
    },

    // Professores Externos — CRUD para coordenação
    async getProfessoresExternos(params?: { search?: string; page?: number; per_page?: number }) {
        return api.get('/coordenador/professores-externos', { params });
    },

    async createProfessorExterno(data: CreateExternalProfessorForCourseData) {
        return api.post('/coordenador/professores-externos', data);
    },

    async updateProfessorExterno(id: number, data: UpdateExternalProfessorData) {
        return api.put(`/coordenador/professores-externos/${id}`, data);
    },
};
